import { memo, useCallback, useEffect, useMemo } from 'react'
import { t } from '@ocean-club/dapps/dist/modules/translation/utils'
import { isMobile } from '@ocean-club/dapps/dist/lib/utils'
import { Button, Hero, Page } from '@ocean-club/ui'
import { locations } from '../../modules/routing/locations'
import { VendorName } from '../../modules/vendor/types'
import { SortBy } from '../../modules/routing/types'
import { View } from '../../modules/ui/types'
import { AssetType } from '../../modules/asset/types'
import { HomepageView } from '../../modules/ui/asset/homepage/types'
import { Section } from '../../modules/vendor/ocean/routing/types'
import { Navbar } from '../Navbar'
import { Footer } from '../Footer'
import { Slideshow } from './Slideshow'
import { Props } from './HomePage.types'
import './HomePage.css'
import * as decentraland from '../../modules/vendor/ocean'

const HomePage = (props: Props) => {
  const {
    homepage,
    homepageLoading,
    onNavigate,
    onFetchAssetsFromRoute
  } = props

  const sections: Partial<Record<View, Section>> = useMemo(
    () => ({
      // [View.HOME_ITEMS]: Section.WEARABLES,
      [View.HOME_WEARABLES]: Section.WEARABLES,
      // [View.HOME_LAND]: Section.LAND,
      // [View.HOME_ENS]: Section.ENS
    }),
    []
  )

  const assetTypes: Partial<Record<View, AssetType>> = useMemo(
    () => ({
      // [View.HOME_ITEMS]: AssetType.ITEM,
      [View.HOME_WEARABLES]: AssetType.NFT,
      // [View.HOME_LAND]: AssetType.NFT,
      // [View.HOME_ENS]: AssetType.NFT
    }),
    []
  )

  const handleGetStarted = useCallback(() => {
    onNavigate(locations.browse({
      section: decentraland.Section.WEARABLES,
      vendor: VendorName.OCEAN,
      assetType: AssetType.NFT,
      page: 1,
      sortBy: SortBy.RECENTLY_LISTED,
      onlyOnSale: true
    }))
  }, [onNavigate])

  const handleViewAll = useCallback(
    (view: View) => {
      const section = sections[view]
      const assetType = assetTypes[view]
      onNavigate(locations.browse({ section, assetType }))
    },
    [sections, assetTypes, onNavigate]
  )

  const vendor = VendorName.OCEAN

  useEffect(() => {
    let view: HomepageView
    for (view in homepage) {
      const assetType = assetTypes[view]
      const section = sections[view]
      onFetchAssetsFromRoute({
        vendor,
        section,
        view,
        assetType,
        sortBy: SortBy.RECENTLY_LISTED,
        page: 1,
        onlyOnSale: true
      })
    }
    // eslint-disable-next-line
  }, [onFetchAssetsFromRoute])

  const views = Object.keys(homepage) as HomepageView[]

  return (
    <>
      <Navbar isFullscreen isOverlay />
      <Hero centered={isMobile()} className="HomePageHero">
        <Hero.Header>{t('home_page.title')}</Hero.Header>
        <Hero.Description>{t('home_page.subtitle')}</Hero.Description>
        <Hero.Content>
          <div className="hero-image" />{' '}
        </Hero.Content>
        <Hero.Actions>
          <Button primary onClick={handleGetStarted}>
            {t('home_page.get_started')}
          </Button>
        </Hero.Actions>
      </Hero>
      <Page className="HomePage">
        {views.map(view => (
          <Slideshow
            key={view}
            title={t(`home_page.${view}`)}
            assets={homepage[view]}
            isLoading={homepageLoading[view]}
            onViewAll={() => handleViewAll(view)}
          />
        ))}
      </Page>
      <Footer />
    </>
  )
}

export default memo(HomePage)
